const validate = values => {
  const errors = {}

  if (!values.places_form?.centerMapAddress) {
    errors.places_form = {
      ...errors?.places_form,
      centerMapAddress: "The back up location is required!",
    }
  }

  if (!values.places_form?.mapUrl) {
    errors.places_form = {
      ...errors?.places_form,
      mapUrl: "The URL required!",
    }
  } else if (
    !/(http(s)?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values.places_form?.mapUrl
    )
  ) {
    errors.places_form = {
      ...errors?.places_form,
      mapUrl:
        "The URL is invalid! It must include both http:// or https:// and a suffix like .com",
    }
  }

  if (!values.places_form?.mapKey) {
    errors.places_form = {
      ...errors.places_form,
      mapKey: "The KEY required!",
    }
  }

  if (values.places_form?.feedback && !values.places_form?.survey) {
    errors.places_form = {
      ...errors.places_form,
      survey: "Required!",
    }
  }

  if (
    values.places_form?.enableStarredLocations &&
    !values.places_form?.starredLocationLabel
  ) {
    errors.places_form = {
      ...errors.places_form,
      starredLocationLabel: "The starred location label is required!",
    }
  }

  if (!values.places_form?.zoomLevel) {
    errors.places_form = {
      ...errors.places_form,
      zoomLevel: "The zoom level is required!",
    }
  }

  if (values.places_form?.enableNotification) {
    if (!values.places_form?.notificationReminder)
      errors.places_form = {
        ...errors.places_form,
        notificationReminder: "Required!",
      }

    if (!values.places_form?.notificationsurvey)
      errors.places_form = {
        ...errors.places_form,
        notificationsurvey: "Required!",
      }
  }

  return errors
}

export default validate
